








































































import Vue, { PropType } from 'vue';

export type Image = {
  id: string | null;
  fileName: string;
  description?: string;
  isApproval: boolean;
}

export type UserInfoData = {
  name: string;
  kana: string;
  department: string;
  email: string;
  phoneNumber: string;
  image: Image;
}

export default Vue.extend({
  name: 'GUserInfo',
  props: {
    user: {
      type: Object as PropType<UserInfoData>,
      default: () => ({}),
    },
  },
  // methods: {
  //   submit() {
  //     this.$emit('submit', this.user);
  //   },
  // },
});
